import { classNames } from 'primereact/utils';
import { Suspense, useEffect, useRef, useState, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { Tooltip } from 'primereact/tooltip';
import { useLocation, useNavigate } from 'react-router-dom';
import AppFooter from '../AppFooter';
import AppMenu from '../AppMenu';
import Breadcrumbs from '../utilities/breadcrumb';

import { Toast } from 'primereact/toast';

import { Dialog } from 'primereact/dialog';
import { ProgressBar } from 'primereact/progressbar';
import ArtikalForm from '../components/artikal/ArtikalForm';

import menu from '../menu';

// podrška za QR skener
import onScan from 'onscan.js';
import { QrScaner } from '../utilities/QrScaner';

import { useHotkeys } from 'react-hotkeys-hook';

import AppTopbar from '../AppTopbar';

import i18n from '../i18n';
import { useScanResult } from '../store';
const secretKey = 'boxprice';

const appName = process.env.REACT_APP_NAME;

const MainLayout = () => {
    const [layoutMode, setLayoutMode] = useState('slim');
    const [lightMenu, setLightMenu] = useState(true);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [isRTL, setIsRTL] = useState(false);
    const [inlineUser, setInlineUser] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [rightPanelMenuActive, setRightPanelMenuActive] = useState(null);
    const [inlineUserMenuActive, setInlineUserMenuActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [topbarColor, setTopbarColor] = useState('layout-topbar-blue');
    //const [theme, setTheme] = useState('blue');
    const [configActive, setConfigActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('filled');
    const [ripple, setRipple] = useState(false);
    const [showQrScaner, setShowQrScaner] = useState(false);
    const [showArtikalDialog, setArtikalDialogVisible] = useState(false);
    const [showFakturaDialog, setFakturaDialogVisible] = useState(false);
    const copyTooltipRef = useRef();
    const location = useLocation();
    //const inlineUserRef = useRef();
    const toast = useRef(null);

    const addScanResult = useScanResult().addScanResult;

    const onScanneHandler = (result) => {
        setShowQrScaner(false);
        if (addScanResult(result)) {
            navigate(`/mm/${result}/barcode/`);
            // console.log('Skeniranje uspešno: ' + result);
        } else {
            navigate('/mm/newnalog');
        }
    };

    const onScanneCloseHandler = (result) => {
        setShowQrScaner(false);
        navigate('/mm/newnalog');
    };

    const navigate = useNavigate();

    useHotkeys('F2', () => {
        setArtikalDialogVisible(true);
    });

    useHotkeys('F6', () => {
        setFakturaDialogVisible(true);
    });

    let topbarItemClick;
    let menuClick;
    let rightMenuClick;
    let userMenuClick;
    let configClick = false;

    const lastItem = {
        label: 'Back',
        icon: 'pi pi-fw pi-arrow-left',
        command: () => {
            navigate(-1);
        }
    };

    useEffect(() => {
        onScan.attachTo(document, {
            suffixKeyCodes: [13], // enter-key expected at the end of a scan
            reactToPaste: false, // use paste events as fallback
            ignoreIfShift: false,
            captureEvents: false, //
            ignoreIfFocusOn: ['input', 'textarea'], // ignore scans on input and textarea
            reactToKeyDown: false, // use keydown events as fallback
            // //filter: /[a-zA-Z0-9.]+/,
            keyCodeMapper: function (oEvent) {
                switch (oEvent.key) {
                    case 'Enter':
                        return 13;
                    case 'Shift':
                        return '';
                    case 'Control':
                    case 'ControlLeft':
                    case 'ControlRight':
                        return '';
                    case '~':
                        return '|';
                    case '|':
                        return '|';
                    case 'Space':
                        return ' ';
                    case 'ArrowDown':
                        return '';
                    case 'ArrowUp':
                        return '';
                    case 'ArrowLeft':
                        return '';
                    case 'ArrowRight':
                        return '';
                    default:
                        return oEvent.key;
                }
            },
            onScan: function (sCode, iQty) {
                // console.log('Original plaintext: ' + sCode);
                if (sCode) {
                    addScanResult(sCode);
                }
            }
        });

        // Cleanup on unmount
        return () => {
            onScan.detachFrom(document);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        // if (AuthService.isLoggedin() === false) {
        //     navigate('/login');
        // }
    }, [navigate]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (staticMenuMobileActive) {
            blockBodyScroll();
        } else {
            unblockBodyScroll();
        }
    }, [staticMenuMobileActive]);

    // const onRippleChange = (e) => {
    //     PrimeReact.ripple = e.value;
    //     setRipple(e.value);
    // };

    const onDocumentClick = () => {
        if (!topbarItemClick) {
            setActiveTopbarItem(null);
            setTopbarMenuActive(false);
        }

        if (!rightMenuClick) {
            setRightPanelMenuActive(false);
        }

        if (!userMenuClick && isSlim() && !isMobile()) {
            setInlineUserMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                hideOverlayMenu();
            }

            unblockBodyScroll();
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        topbarItemClick = false;
        menuClick = false;
        rightMenuClick = false;
        userMenuClick = false;
        configClick = false;
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setTopbarMenuActive(false);
        setRightPanelMenuActive(false);

        if (layoutMode === 'overlay') {
            setOverlayMenuActive((prevOverlayMenuActive) => !prevOverlayMenuActive);
        }

        if (isDesktop()) setStaticMenuDesktopInactive((prevStaticMenuDesktopInactive) => !prevStaticMenuDesktopInactive);
        else {
            setStaticMenuMobileActive((prevStaticMenuMobileActive) => !prevStaticMenuMobileActive);
            if (staticMenuMobileActive) {
                blockBodyScroll();
            } else {
                unblockBodyScroll();
            }
        }

        event.preventDefault();
    };

    const onTopbarMenuButtonClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevTopbarMenuActive) => !prevTopbarMenuActive);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;

        if (activeTopbarItem === event.item) setActiveTopbarItem(null);
        else setActiveTopbarItem(event.item);

        event.originalEvent.preventDefault();
    };

    const onQrIconClick = (event) => {
        //  topbarItemClick = true;
        setShowQrScaner(true);
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const blockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const onRightMenuButtonClick = (event) => {
        rightMenuClick = true;
        setRightPanelMenuActive((prevRightPanelMenuActive) => !prevRightPanelMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
        }
        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const onRootMenuItemClick = () => {
        setMenuActive((prevMenuActive) => !prevMenuActive);
        setInlineUserMenuActive(false);
    };

    const isDesktop = () => {
        return window.innerWidth > 896;
    };

    const isMobile = () => {
        return window.innerWidth <= 1025;
    };

    const isHorizontal = () => {
        return layoutMode === 'horizontal';
    };

    const isSlim = () => {
        return layoutMode === 'slim';
    };

    const onArticalCreate = () => {
        // console.log('Artikal created');
        setArtikalDialogVisible(false);
        toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('success_created'), life: 3000 });
    };

    const layoutClassName = classNames(
        'layout-wrapper',
        {
            'layout-horizontal': layoutMode === 'horizontal',
            'layout-overlay': layoutMode === 'overlay',
            'layout-static': layoutMode === 'static',
            'layout-slim': layoutMode === 'slim',
            'layout-menu-light': lightMenu,
            'layout-menu-dark': !lightMenu,
            'layout-overlay-active': overlayMenuActive,
            'layout-mobile-active': staticMenuMobileActive,
            'layout-static-inactive': staticMenuDesktopInactive,
            'layout-rtl': isRTL,
            'p-input-filled': inputStyle === 'filled',
            'p-ripple-disabled': !ripple
        },
        topbarColor
    );

    return (
        <div style={{ minHeight: 'calc(100vh - 144px)' }}>
            <div className={layoutClassName} onClick={onDocumentClick}>
                <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
                <AppTopbar
                    appName={appName}
                    topbarMenuActive={topbarMenuActive}
                    activeTopbarItem={activeTopbarItem}
                    inlineUser={inlineUser}
                    onRightMenuButtonClick={onRightMenuButtonClick}
                    onMenuButtonClick={onMenuButtonClick}
                    onTopbarMenuButtonClick={onTopbarMenuButtonClick}
                    onTopbarItemClick={onTopbarItemClick}
                    onQrIconClick={onQrIconClick}
                />
                <div className="layout-menu-container" onClick={onMenuClick}>
                    <AppMenu model={menu} onMenuItemClick={onMenuItemClick} onRootMenuItemClick={onRootMenuItemClick} layoutMode={layoutMode} active={menuActive} mobileMenuActive={staticMenuMobileActive} />
                </div>
                <div className="layout-main">
                    <div className="layout-content m-0  md:m-2 p-2">
                        {/* <Breadcrumbs /> */}
                        <Suspense fallback={<ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>}>
                            <Outlet />
                        </Suspense>
                    </div>
                    <AppFooter />
                </div>
            </div>
            <Dialog header={'Barkod čitač'} visible={showQrScaner} style={{ minWidth: '24rem' }} onHide={() => setShowQrScaner(false)}>
                <QrScaner onScane={onScanneHandler} onClose={onScanneCloseHandler}></QrScaner>
            </Dialog>
            <Dialog visible={showArtikalDialog} style={{ minWidth: '24rem', width: '90%' }} onHide={() => setArtikalDialogVisible(false)}>
                <ArtikalForm dialogForm={true} onArticalCreate={onArticalCreate}></ArtikalForm>
            </Dialog>

            <Toast ref={toast} />
        </div>
    );
};
export default MainLayout;
